import { createContext } from 'react';
import { ID, Response } from '../../../../../_dashboard/helpers';

export interface Agency {
  _id?: ID;
  name: string;
  address: string;
  city: string;
  phone: string;
  email?: string;
  contactPerson?: string;
  isActive?: boolean;
  notes?: string;
  openingHours?: string;
}

export const initialAgency: Agency = {
  name: '',
  address: '',
  city: '',
  phone: '',
  email: '',
  contactPerson: '',
  isActive: true,
  notes: '',
  openingHours: '',
};

export type AgenciesQueryResponse = Response<Array<Agency>>;
export type QueryResponseAgencyContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined;
  refetchData: () => void;
  isLoading: boolean;
  query: any;
};

export function createAgencyResponseContext<T>(initialState: QueryResponseAgencyContextProps<T>) {
  return createContext(initialState);
}

export const initialAgencyQueryResponse = { refetchData: () => {}, isLoading: false, query: '' };
